var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isValidDate)?_c('time',{attrs:{"datetime":_vm.date.toISOString()}},[_vm._v(_vm._s(_vm.shortDate(_vm.date)))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }